export default "__VITE_ASSET__CDfueWD6__"